import { FC } from 'react';

import { Currency } from '@/constants';
import { useTokenUsdPrices } from '@/hooks/useTokenUsdPrices';
import { formatAmountToFiat, formatDecimalsAmount } from '@/shared/components/UtxoSelect/utils';
import { cn } from '@/utils';
import Big from '@/utils/Bigjs';

interface UtxoSelectModalInfoElementProps {
  label: string;
  value: string | number | bigint | React.ReactNode;
  className?: string;
}

export const UtxoSelectModalInfoElement: FC<UtxoSelectModalInfoElementProps> = ({ label, value, className }) => {
  return (
    <div
      className={cn(
        'border-bg-background flex flex-col items-start justify-center gap-2 overflow-hidden rounded-lg border p-2',
        className
      )}
    >
      <span className="text-muted-foreground text-xs">{label}</span>
      <span className="w-full truncate text-sm">{typeof value === 'bigint' ? value.toString() : value}</span>
    </div>
  );
};

interface UtxoSelectModalInfoElementSatoshisProps {
  label: string;
  value?: bigint | number;
  className?: string;
  shouldShowFiatPrice?: boolean;
}

export const UtxoSelectModalInfoElementSatoshis: FC<UtxoSelectModalInfoElementSatoshisProps> = ({
  label,
  value,
  className,
  shouldShowFiatPrice,
}) => {
  const { getTokenUsdPrice } = useTokenUsdPrices();

  const formattedValue = shouldShowFiatPrice
    ? formatAmountToFiat(Currency.BTC, value || 0n, getTokenUsdPrice(Currency.BTC))
    : formatDecimalsAmount(Currency.BTC, value || 0n);

  return (
    <UtxoSelectModalInfoElement
      label={label}
      value={formattedValue}
      className={cn(className, Big((value || 0n).toString()).lt(0) && 'text-red-500')}
    />
  );
};
